if (document.querySelector(".carrossel-logos")) {
    var swiper_categogias = new Swiper(".carrossel-logos .swiper", {
        slidesPerView: 'auto',
        spaceBetween: 20,
        loop: true,
        speed: 5000,
        autoplay: {
            delay: 1,
            pauseOnMouseEnter: false,
            disableOnInteraction: false
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        allowTouchMove: false,
        breakpoints: {
            580: {
                spaceBetween: 40
            },
            991: {
                spaceBetween: 80
            }
        }
    });
}

jQuery(function ($) {
    
    $('#header a[href="#"]').on('click', function (e) {
        e.preventDefault();
        $('.sub-menu').hide();
        var submenu = $(this).next('.sub-menu');
        if (submenu.length) {
            submenu.stop().slideToggle();
        }
    });

    $('#mobile-nav a[href="#"]').on('click', function (e) {
        e.preventDefault();
        $('.sub-menu').hide();
        var submenu = $(this).next('.sub-menu');
        if (submenu.length) {
            submenu.stop().slideToggle();
        }
    });

});